import { Box, SxProps, Theme, Typography } from '@mui/material'

export interface PageSubtitleProps {
  title: string
  sx?: SxProps<Theme>
}

/**
 * Display a ttile for a page,
 */
export const PageSubtitle = (props: PageSubtitleProps): JSX.Element => {
  return (
    <Box sx={{ mb: 1, mt: 2, ...props.sx }}>
      <Typography variant="h2">{props.title}</Typography>
    </Box>
  )
}
